import { html } from "lit-html";

export default html`<svg
	width="11"
	height="9"
	viewBox="0 0 11 9"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<g clip-path="url(#clip0_350_67069)">
		<path
			d="M1.05501 4.754L4.38701 7.44501L9.07802 1.045"
			stroke="#202A36"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</g>
	<defs>
		<clipPath id="clip0_350_67069">
			<rect width="10.126" height="8.195" fill="white" />
		</clipPath>
	</defs>
</svg>`.strings.join("");
